"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE = exports.EnrichUserRole = exports.ENRICH_REDUX_SLICE_KEY = exports.createEnrichReducers = exports.EnrichActionCreators = exports.EnrichFeatureFlag = exports.SpeedIcon = exports.PencilAndPaperIcon = exports.NotificationsIcon = exports.LayersIcon = exports.GridViewIcon = exports.FolderCheckedIcon = exports.ChecklistIcon = exports.ENRICH = exports.ENRICH_DRAWER_SECTION = exports.useUserRoutePermissions = exports.getEnrichDrawerRoutes = exports.EnrichSection = exports.EnrichRouter = exports.EnrichContext = void 0;
const enrich_managers_1 = __importDefault(require("./enrich.managers"));
var context_1 = require("./context");
Object.defineProperty(exports, "EnrichContext", { enumerable: true, get: function () { return context_1.EnrichContext; } });
exports.default = enrich_managers_1.default;
var router_1 = require("./router");
Object.defineProperty(exports, "EnrichRouter", { enumerable: true, get: function () { return router_1.EnrichRouter; } });
Object.defineProperty(exports, "EnrichSection", { enumerable: true, get: function () { return router_1.EnrichSection; } });
Object.defineProperty(exports, "getEnrichDrawerRoutes", { enumerable: true, get: function () { return router_1.getEnrichDrawerRoutes; } });
Object.defineProperty(exports, "useUserRoutePermissions", { enumerable: true, get: function () { return router_1.useUserRoutePermissions; } });
Object.defineProperty(exports, "ENRICH_DRAWER_SECTION", { enumerable: true, get: function () { return router_1.ENRICH_DRAWER_SECTION; } });
Object.defineProperty(exports, "ENRICH", { enumerable: true, get: function () { return router_1.ENRICH; } });
var icons_1 = require("./icons");
Object.defineProperty(exports, "ChecklistIcon", { enumerable: true, get: function () { return icons_1.ChecklistIcon; } });
Object.defineProperty(exports, "FolderCheckedIcon", { enumerable: true, get: function () { return icons_1.FolderCheckedIcon; } });
Object.defineProperty(exports, "GridViewIcon", { enumerable: true, get: function () { return icons_1.GridViewIcon; } });
Object.defineProperty(exports, "LayersIcon", { enumerable: true, get: function () { return icons_1.LayersIcon; } });
Object.defineProperty(exports, "NotificationsIcon", { enumerable: true, get: function () { return icons_1.NotificationsIcon; } });
Object.defineProperty(exports, "PencilAndPaperIcon", { enumerable: true, get: function () { return icons_1.PencilAndPaperIcon; } });
Object.defineProperty(exports, "SpeedIcon", { enumerable: true, get: function () { return icons_1.SpeedIcon; } });
var feature_flags_1 = require("./feature-flags");
Object.defineProperty(exports, "EnrichFeatureFlag", { enumerable: true, get: function () { return feature_flags_1.FeatureFlag; } });
exports.EnrichActionCreators = __importStar(require("./store/actions/creators"));
var reducers_1 = require("./store/reducers");
Object.defineProperty(exports, "createEnrichReducers", { enumerable: true, get: function () { return __importDefault(reducers_1).default; } });
var const_1 = require("./store/const");
Object.defineProperty(exports, "ENRICH_REDUX_SLICE_KEY", { enumerable: true, get: function () { return const_1.ENRICH_REDUX_SLICE_KEY; } });
var state_1 = require("./store/state");
Object.defineProperty(exports, "EnrichUserRole", { enumerable: true, get: function () { return state_1.UserRole; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE", { enumerable: true, get: function () { return constants_1.ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE; } });
